var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.52,
    height: 18.52,
    viewBox: "0 0 18.52 18.52",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_9_wyloguj"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.52,
    height: 18.52
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_9_wyloguj",
    "data-name": "9 wyloguj",
    clipPath: "url(#clip-_9_wyloguj)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "exit",
    d: "M13.561,14.183V15.63a2.9,2.9,0,0,1-2.894,2.894H3.394A2.9,2.9,0,0,1,.5,15.63V2.894A2.9,2.9,0,0,1,3.394,0h7.272a2.9,2.9,0,0,1,2.894,2.894V4.342a.724.724,0,0,1-1.447,0V2.894a1.449,1.449,0,0,0-1.447-1.447H3.394A1.449,1.449,0,0,0,1.947,2.894V15.63a1.449,1.449,0,0,0,1.447,1.447h7.272a1.449,1.449,0,0,0,1.447-1.447V14.183a.724.724,0,0,1,1.447,0Zm4.933-6.164L16.874,6.4a.724.724,0,0,0-1.023,1.023L17,8.575H8.315a.724.724,0,1,0,0,1.447H17l-1.153,1.153A.724.724,0,1,0,16.874,12.2l1.62-1.62a1.811,1.811,0,0,0,0-2.558Zm0,0",
    transform: "translate(-0.5)",
    fill: "#f6f7fb"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.37240364.svg";
export { ForwardRef as ReactComponent };